import useSWR from 'swr'
import { client } from '~editor/utils/gg_client'

const fetcher = (url: string) => client(url).then((res) => res.data)

export const useSWRHelper = (url?: string | null | false) => {
  return useSWR(url || null, fetcher)
}
